const ADMIN_EMPLOYERS = {
  SET_EMPLOYErS_QUERY: 'SET_ADMIN_EMPLOYERS_QUERY',
};

export default ADMIN_EMPLOYERS;
